import script from "./PersonalProjects.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonalProjects.vue?vue&type=script&setup=true&lang=js"

import "./PersonalProjects.vue?vue&type=style&index=0&id=7ce911d0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ce911d0"]])

export default __exports__